// The Retailers list's Notes tab scopes the page to retailers with notes the way the media views do:
// through the Advanced Search boolean `has_notes` ("Only show retailers with notes", P20M-1242 R13).
// Applied on the way in and dropped on the way out, so its chip, the Advanced Search drawer and the URL
// say what the tab shows, and it never lingers on List/Map as a filter the user didn't set.
// `applyFilters` replaces the whole filter slice, so callers pass the full returned object.
//
// The NOTES section of Advanced Search (note_date_from/to, note_author, note_visit_type, note_text —
// P20M-1242 R18) only exists on the Notes tab, so its filters leave with has_notes: on List/Map the
// drawer has no field and no chip for them, and they would still narrow the table.

export const withNotesFilter = (generalFilters = {}) => ({ ...generalFilters, has_notes: '1' });

// Just the NOTES section's note_* filters. The visits lists use this one: their Notes view scopes
// nothing through has_notes, so a has_notes the user ticked is theirs to keep.
export const withoutNoteFieldFilters = (generalFilters = {}) => {
  const next = { ...generalFilters };
  Object.keys(next).forEach((key) => {
    if (key.startsWith('note_')) delete next[key];
  });
  return next;
};

export const withoutNotesFilter = (generalFilters = {}) => {
  const next = withoutNoteFieldFilters(generalFilters);
  delete next.has_notes;
  return next;
};
